<template>
    <div>
        <template v-for="(scope, key) in scopes">
            <template v-if="typeof scope === 'object' || Array.isArray(scope)">
                <div
                    :id="'id-form-opt-' + key"
                    :key="key"
                    class="form-group"
                    :class="{ 'wp-5': parent === 'all', 'pl-4': key !== 'all' }"
                >
                    <label class="form-label label-auto bold">
                        <input
                            :id="'opt-' + key"
                            type="checkbox"
                            name="options[]"
                            :value="`${key}`"
                            :checked="isChecked(key)"
                            @change="handleChecked(key, scope, $event.target.checked, true)"
                        />
                        {{ key === 'all' ? $l10n.__('Tous') : key }}
                    </label>
                    <ScopesInput
                        :class="{ 'scope-group': !parent }"
                        :scopes="scope ? scope : []"
                        :modelValue="modelValue"
                        :parent="key"
                        :handleChecked="handleChecked"
                    />
                </div>
            </template>
            <template v-else>
                <div :key="key" class="form-group ml-4">
                    <label class="form-label label-auto">
                        <input
                            :id="'opt-' + scope"
                            type="checkbox"
                            name="options[]"
                            :value="`${scope}`"
                            :checked="isChecked(scope)"
                            @change="handleChecked(key, scope, $event.target.checked, true)"
                        />
                        {{ scope }}
                    </label>
                </div>
            </template>
        </template>
    </div>
</template>
<script>
export default {
    name: 'ScopesInput',
    props: {
        scopes: {
            type: [Object, Array],
            default: () => [],
            required: true,
        },
        modelValue: {
            type: [Array],
            default: () => [],
        },
        parent: {
            type: String,
            default: '',
        },
        handleChecked: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            options: [],
        };
    },
    created() {
        const options = this.scopes.all;
    },
    methods: {
        isChecked(value) {
            return this.modelValue.includes(value);
        },
    },
};
</script>
<style lang="scss" scoped>
.scope-group {
    display: block;
    flex-wrap: wrap;
    overflow: auto;
    max-height: 400px;
}

#id-form-opt-private {
    padding-left: 0 !important;
}
</style>
